import { render, staticRenderFns } from "./AddDatesToProduct.vue?vue&type=template&id=a6a37da4&"
import script from "./AddDatesToProduct.vue?vue&type=script&lang=js&"
export * from "./AddDatesToProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports